import api from "@/libs/axios";
import * as ep from "../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
  },
  actions: {
    async updateUser({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.put(ep.USER_BY_ID(payload.id), payload.fd);
        dispatch("handleResponse", res);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },
    async updateRouls({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.post(ep.ROLE_BY_ID(payload.id), payload.fd);
        dispatch("handleResponse", res);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },

    async deleteUser({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.delete(ep.USER_BY_ID(payload.id));
        dispatch("handleResponse", res);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },

    async changePassword({ commit, dispatch }, payload) {
      try {
        const res = api.post(ep.PASSWORD(payload.id), payload.fd);
        dispatch("handleResponse", res);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },

    async addUser({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await api.post(ep.USERS, payload.fd);
        dispatch("handleResponse", res);
        return Promise.resolve();
      } catch (err) {
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },
    handleResponse({ commit, dispatch }, res) {
      if (res.status > 399 && res.status <= 500) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        throw res.status;
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت العملية بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      }
    },
  },
};
